import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  CircularProgress,
  Collapse,
  Divider,
  Paper,
  Popover,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  styled,
  tableCellClasses,
  Button,
  Card,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomTypography from "../../globalStyles/fonts";
import { carrierService } from "../../utils/services/carrierService";
import { clientService } from "../../utils/services/clientService";
import AppContext from "../context/context";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import ClientConfiguration from "../client-configuration";
import { isMobile } from "../../globalStyles/mobile";
import ClientDetailsModal from "../clientViewDetailsModal";
import WarehouseSelectionModal from "../oms-location-modal";
import ProfileIcon from "@mui/icons-material/RoomPreferences";
import { userService } from "../../utils/services/userService";
import { useNavigate } from "react-router-dom";
import { providerService } from "../../utils/services/providerService";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTheme } from "@mui/styles";
import EditIcon from "../../globalStyles/icons/editIcon";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import ClientMobileCard from "./client-mobile-card";
import { loginService } from "../../utils/services/loginService.js";
import ClientProviderModal from "../client-provider-modal/index.js";
import PhonelinkSetupOutlinedIcon from "@mui/icons-material/PhonelinkSetupOutlined";
import ClientSetupStatusModal from "../client-setup-modal/index.js";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonIcon from "@mui/icons-material/Person";
import UserModal from "../users-modal.js";
import AssignExistingUserModal from "../assign-existing-user-modal/index.js";
import { IOSSwitch } from "../switch/index.js";
import TableHeader from "../table-header/index.js";
import FilterModal from "../filterModal/index.js";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import ForecastSettingsDialog from "../forecast-policy/ForecastSettingsDialog";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { arciveOrderService } from "../../utils/services/archive-order.service";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "1px solid var(--border-color)",
    color: "var(--text-primary)",
    padding: "6px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
    color: "var(--text-primary)",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme, isExpandable }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: isExpandable ? "var(--bg-highlight)" : "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: isExpandable
      ? "var(--bg-highlight)"
      : "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },

  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ClientList = ({
  client,
  data,
  onEditData,
  onDeleteData,
  handleEditClient,
  viewMode,
  onViewItem,
  onChangeStatus,
  onSuccess,
  currentPage,
  itemsPerPage,
  onChangeFilter,
  filterData,
}) => {
  const [clientData, setClientData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [forecastSettingsClient, setForecastSettingsClient] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectClientId, setSelectClientId] = useState(null);
  const [wms, setWms] = useState(false);
  const [tms, setTms] = useState(false);
  const { user, setUser } = useContext(AppContext);
  const [openOmsModal, setOpenOmsModal] = useState(false);
  const [openProviderModal, setOpenProviderModal] = useState(false);
  const [openRow, setOpenRow] = useState(null);
  const [providerData, setProviderData] = useState({
    oms: [],
    tms: [],
    wms: [],
  });
  const [setupModalOpen, setSetupModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openWarehouseList, setOpenWarehouseList] = useState(false);
  const [providerList, setProviderList] = useState([]);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [selectedfilterData, setSelectedFilterData] = useState({
    key: "",
    name: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "name",
    fetchApi: () => {},
    loadMoreButton: false,
    options: [],
    searchKey: "",
  });
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const secondary_color = theme.palette?.secondary?.main || defaultColor;
  const navigate = useNavigate();
  const startIndex = currentPage * itemsPerPage;
  const [menuPosition, setMenuPosition] = useState(null);
  const menuRef = useRef(null);
  const [selectedProvider, setSelectedProvider] = useState({});
  const [viewOnly, setViewOnly] = useState(false);
  const [inventoryStatus, setInventoryStatus] = useState(false);
  const [syncModalOpen, setSyncModalOpen] = useState(false);
  const [syncClient, setSyncClient] = useState(null);
  const [syncStartDate, setSyncStartDate] = useState(null);
  const [syncEndDate, setSyncEndDate] = useState(null);
  const [syncError, setSyncError] = useState("");
  const [openManagedOrchConfirmation, setOpenManagedOrchConfirmation] =
    useState(false);
  const [openAssignUserChoice, setOpenAssignUserChoice] = useState(false);
  const [openCreateAndAssign, setOpenCreateAndAssign] = useState(false);
  const [openAssignExisting, setOpenAssignExisting] = useState(false);
  const handleMenuOpen = (event, client) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const menuHeight = 120; // Approx height of the menu (adjust as needed)
    const menuWidth = 200; // Approx width of the menu (adjust as needed)
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let calculatedX = rect.left + window.scrollX;
    let calculatedY = rect.top + window.scrollY + rect.height;

    // Adjust for bottom boundary overflow
    if (calculatedY + menuHeight > viewportHeight) {
      calculatedY = viewportHeight - menuHeight - 10; // 10px padding
    }

    // Adjust for right boundary overflow
    if (calculatedX + menuWidth > viewportWidth) {
      calculatedX = viewportWidth - menuWidth - 10; // 10px padding
    }

    setMenuPosition({ x: calculatedX, y: calculatedY });
    setSelectedClient(client);
  };

  const handleMenuClose = () => {
    setMenuPosition(null);
    setSelectedClient(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleMenuClose();
      }
    };

    if (menuPosition) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuPosition]);

  const handleRowClick = (index) => {
    setOpenRow(openRow === index ? null : index);
  };

  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setOpenFilterModal(true);
    setSelectedFilterData(filterData?.columns.find((x) => x?.key == filterKey));
  };
  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });
    handleCloseFilter();
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  useEffect(() => {
    fetchProviders();
  }, []);

  const fetchProviders = async () => {
    try {
      const response = await providerService.fetch(100, 0);
      setProviderList(response?.data);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const changeClientStatus = async (id, status) => {
    setLoading(true);
    try {
      const response = await clientService.edit(
        {
          status: status,
        },
        id,
      );
      if (onChangeStatus) onChangeStatus();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Fetch failed:", error);
    }
  };

  const handleManagedOrchestrationToggle = async (clientId, currentValue) => {
    setLoading(true);
    try {
      await clientService.edit(
        { managed_orchestration: !currentValue },
        clientId,
      );
      if (onChangeStatus) onChangeStatus();
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExcludeInventoryToggle = async (clientId, newValue) => {
    setLoading(true);
    try {
      const response = await clientService.edit(
        {
          order_exclude_inventory: !newValue,
        },
        clientId,
      );
      if (onChangeStatus) onChangeStatus();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Fetch failed:", error);
    }
  };
  const handleEnterClientProfile = async (data) => {
    setLoading(true);
    try {
      const response = await userService.fetchUserByEmail(
        data.email,
        data._id,
      );
      const adminData = localStorage.getItem("user");
      localStorage.setItem("adminUser", adminData);
      localStorage.removeItem("user");
      let admin_token = localStorage.getItem("token");
      localStorage.removeItem("token");
      let admin_roles = localStorage.getItem("roles");
      localStorage.removeItem("roles");
      localStorage.removeItem("sidemenuItems");
      localStorage.setItem("admin_roles", admin_roles);
      localStorage.setItem("token", response.accessToken);
      localStorage.setItem("adminToken", admin_token);
      localStorage.setItem("roles", JSON.stringify(response.user.roles));

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...response.user,
          roles: response.user.roles.map((x) => x._id),
        }),
      );
      setUser(response.user);
      localStorage.setItem("client_id", data._id);
      let resp = await loginService.login_oms(response);

      localStorage.setItem("rl_oms_token", resp?.token);
      localStorage.setItem("rl_oms_user", JSON.stringify(resp?.user));
      navigate("/", { replace: true });
      window.location.reload();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Fetch failed:", error);
    }
  };
  const confirmDelete = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await carrierService.delete(selectedClient._id);
      if (onDeleteData) onDeleteData();
      setOpenConfirmation(false);
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const sendActivationKey = async (id, email) => {
    try {
      setLoading(true);
      const response = await clientService.sendActivationKey(id, email);
      setLoading(false);
    } catch (error) {
      console.error("Delete failed:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const syncDateFieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "var(--bg-primary)",
      color: "var(--text-primary)",
      transition: "all 0.2s ease",
      "& fieldset": {
        borderColor: "var(--border-color)",
      },
      "&:hover fieldset": {
        borderColor: primary_color,
      },
      "&.Mui-focused fieldset": {
        borderColor: primary_color,
      },
      "&.Mui-focused": {
        boxShadow: `0 0 0 3px ${primary_color}22`,
      },
    },
    "& .MuiInputLabel-root": {
      color: "var(--text-secondary)",
      fontWeight: 500,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: primary_color,
    },
    "& .MuiSvgIcon-root": {
      color: "var(--text-secondary)",
    },
  };

  const handleOpenSyncModal = (client) => {
    setSyncClient(client);
    setSyncStartDate(null);
    setSyncEndDate(null);
    setSyncError("");
    setSyncModalOpen(true);
  };

  const handleCloseSyncModal = () => {
    setSyncModalOpen(false);
    setSyncClient(null);
    setSyncError("");
  };

  const handleSyncConfirm = async () => {
    if (!syncStartDate || !syncEndDate) {
      setSyncError("Please select both start and end date & time.");
      return;
    }
    const client = syncClient;
    setSyncModalOpen(false);
    await syncHistoricalData(client, syncStartDate, syncEndDate);
  };

  const syncHistoricalData = async (client, startDate, endDate) => {
    setLoading(true);
    try {
      const payload = {
        client_id: client?._id,
        ...(startDate && endDate
          ? {
              start_date: dayjs(startDate).startOf("day").toISOString(),
              end_date: dayjs(endDate).endOf("day").toISOString(),
            }
          : {}),
      };
      await arciveOrderService.syncHistoricalData(payload);
      toast.success("Historical data sync has been successfully initiated!");
    } catch (error) {
      console.error("Sync Historical Data failed:", error);
    } finally {
      setLoading(false);
      setSyncClient(null);
    }
  };

  const handleStatusToggle = (clientId, status, e, email) => {
    e.preventDefault();
    e.stopPropagation();
    if (status === "Approved") {
      changeClientStatus(clientId, "Active");
      sendActivationKey(clientId, email);
    } else if (status === "Active") {
      changeClientStatus(clientId, "Inactive");
    } else {
      changeClientStatus(clientId, "Active");
    }
    // Implement the logic to handle the status toggle
    console.log(`Client ID: ${clientId}, Status: ${status}`);
  };
  const onCloseModal = () => {
    setWms(false);
    setTms(false);
    setSelectedData([]);
    setViewOnly(false);
    setOpenOmsModal(false);
  };
  const ActionButtons = ({
    client,
    status,
    setSelectedClient,
    setTms,
    setWms,
    setOpenProviderModal,
  }) => {
    const isDisabled = ["Inactive", "Uninstalled"].includes(status);

    const handleClick = (type, e) => {
      e.stopPropagation();
      setSelectedClient(client);
      setOpenProviderModal(true);

      if (type === "tms") {
        setTms(true);
        setWms(false);
      } else if (type === "wms") {
        setWms(true);
        setTms(false);
      } else {
        setTms(false);
        setWms(false);
      }
    };

    return (
      <div style={{ width: "100%", display: "flex", gap: 8 }}>
        {/* OMS Button */}
        <Button
          disabled={isDisabled}
          onClick={(e) => handleClick("oms", e)}
          style={{
            padding: 0,
            minHeight: 30,
            border: isDisabled ? "1px solid #BDBDBD" : "1px solid #0070FF",
          }}
          variant="outlined"
          startIcon={
            <AddIcon sx={{ color: isDisabled ? "#BDBDBD" : "#0070FF" }} />
          }
        >
          <Typography
            fontSize="12px"
            color={isDisabled ? "#BDBDBD" : "#0070FF"}
            fontWeight={500}
            fontFamily="poppins"
          >
            OMS
          </Typography>
        </Button>

        {/* TMS Button */}
        <Button
          disabled={isDisabled}
          onClick={(e) => handleClick("tms", e)}
          style={{
            padding: 0,
            minHeight: 30,
            border: isDisabled ? "1px solid #BDBDBD" : "1px solid #007613",
          }}
          variant="outlined"
          startIcon={
            <AddIcon sx={{ color: isDisabled ? "#BDBDBD" : "#007613" }} />
          }
        >
          <Typography
            fontSize="13px"
            color={isDisabled ? "#BDBDBD" : "#007613"}
            fontWeight={500}
            fontFamily="poppins"
          >
            TMS
          </Typography>
        </Button>

        {/* WMS Button */}
        <Button
          disabled={isDisabled}
          onClick={(e) => handleClick("wms", e)}
          style={{
            padding: 0,
            minHeight: 30,
            border: isDisabled ? "1px solid #BDBDBD" : "1px solid #FD7E14",
          }}
          variant="outlined"
          startIcon={
            <AddIcon sx={{ color: isDisabled ? "#BDBDBD" : "#FD7E14" }} />
          }
        >
          <Typography
            fontSize="13px"
            color={isDisabled ? "#BDBDBD" : "#FD7E14"}
            fontWeight={500}
            fontFamily="poppins"
          >
            WMS
          </Typography>
        </Button>
      </div>
    );
  };

  const Action = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "8px",
        }}
      >
        <Button
          style={{
            color: "var(--text-tertiary)",
            justifyContent: "flex-start",
            textTransform: "none",
          }}
          aria-label="edit"
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(null);
            handleEditClient(selectedClient);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            width="100%"
            gap={1}
          >
            <EditIcon />
            <Typography
              fontFamily={"poppins"}
              fontSize={"16px"}
              color={"var(--text-tertiary)"}
              fontWeight={500}
            >
              Edit
            </Typography>
          </Box>
        </Button>

        <Button
          style={{
            color: "var(--text-tertiary)",
            justifyContent: "flex-start",
            textTransform: "none",
          }}
          aria-label="view"
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(null);
            setOpenViewModal(true);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            width="100%"
            gap={1}
          >
            <ViewIcon />
            <Typography
              fontFamily={"poppins"}
              fontSize={"16px"}
              color={"var(--text-tertiary)"}
              fontWeight={500}
            >
              View
            </Typography>
          </Box>
        </Button>

        <Button
          style={{
            color: "var(--text-tertiary)",
            justifyContent: "flex-start",
            textTransform: "none",
          }}
          aria-label="forecast settings"
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(null);
            setForecastSettingsClient(selectedClient);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            width="100%"
            gap={1}
          >
            <InsightsOutlinedIcon />
            <Typography
              fontFamily={"poppins"}
              fontSize={"16px"}
              color={"var(--text-tertiary)"}
              fontWeight={500}
            >
              Forecast Settings
            </Typography>
          </Box>
        </Button>
        {["Pending"].includes(selectedClient?.status) ? (
          <></>
        ) : (
          <>
            <Button
              style={{
                color: "var(--text-tertiary)",
                justifyContent: "flex-start",
                textTransform: "none",
              }}
              aria-label="profile"
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(null);
                handleEnterClientProfile(selectedClient);
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                width="100%"
                gap={1}
              >
                <ProfileIcon color="error" />
                <Typography
                  fontFamily={"poppins"}
                  fontSize={"16px"}
                  color={"var(--text-tertiary)"}
                  fontWeight={500}
                >
                  Profile
                </Typography>
              </Box>
            </Button>
            <Button
              style={{
                color: "var(--text-tertiary)",
                justifyContent: "flex-start",
                textTransform: "none",
              }}
              aria-label="view"
              onClick={(e) => {
                e.stopPropagation();
                //setSelectedClient(client);
                setAnchorEl(null);
                setSetupModalOpen(true);
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                width="100%"
                gap={1}
              >
                <PhonelinkSetupOutlinedIcon />
                <Typography
                  fontFamily={"poppins"}
                  fontSize={"16px"}
                  color={"var(--text-tertiary)"}
                  fontWeight={500}
                >
                  Setup
                </Typography>
              </Box>
            </Button>
            <Button
              style={{
                color: "var(--text-tertiary)",
                justifyContent: "flex-start",
                textTransform: "none",
              }}
              aria-label="sync-historical-data"
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(null);
                handleOpenSyncModal(selectedClient);
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                width="100%"
                gap={1}
              >
                <SyncAltIcon />
                <Typography
                  fontFamily={"poppins"}
                  fontSize={"16px"}
                  color={"var(--text-tertiary)"}
                  fontWeight={500}
                >
                  Sync Orders
                </Typography>
              </Box>
            </Button>
            <Button
              style={{
                color: "var(--text-tertiary)",
                justifyContent: "flex-start",
                textTransform: "none",
              }}
              aria-label="assign-user"
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(null);
                setOpenAssignUserChoice(true);
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                width="100%"
                gap={1}
              >
                <PersonAddIcon />
                <Typography
                  fontFamily={"poppins"}
                  fontSize={"16px"}
                  color={"var(--text-tertiary)"}
                  fontWeight={500}
                >
                  Assign User
                </Typography>
              </Box>
            </Button>
          </>
        )}
      </div>
    );
  };
  useEffect(() => {
    setClientData(
      data?.map((client) => {
        const isDisabled = ["Inactive"].includes(client.status);
        const isSelected = selectedClient === client;

        return {
          ...client,
          action: (
            <div>
              <IconButton
                aria-label="more"
                onClick={(e) => {
                  e.stopPropagation();
                  setAnchorEl(e.currentTarget);
                  setSelectedClient(client);
                }}
                disabled={isDisabled}
                sx={{
                  color: isDisabled
                    ? "#EAECF0"
                    : isSelected
                      ? "primary.main"
                      : "inherit",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                }}
              >
                <MoreVertIcon />
              </IconButton>
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={(e) => {
                  e.stopPropagation();
                  setAnchorEl(null);
                  setSelectedClient(null);
                }}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{
                  "& .MuiPaper-root": {
                    boxShadow: "none",
                    border: "1px solid var(--border-color)",
                    borderRadius: "4px",
                  },
                }}
              >
                <Action></Action>
              </Popover>
            </div>
          ),
        };
      }),
    );
  }, [data, anchorEl]);

  const TableSchema = [
    {
      key: "sl_no",
      title: "SL NO",
      render: (item, index) => (
        <Typography
          fontSize="12px"
          color="var(--text-secondary)"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {startIndex + index + 1}
        </Typography>
      ),
    },
    {
      key: "name",
      title: "Name",
      handleOpenFilter: handleOpenFilter,
      displayKey: "name",
    },
    {
      key: "business_name",
      title: "Business Name",
      handleOpenFilter: handleOpenFilter,
      displayKey: "business_name",
    },
    {
      key: "contact",
      title: "Mobile",
      // handleOpenFilter: handleOpenFilter,
      displayKey: "contact",
    },
    {
      key: "email",
      title: "Email",
      handleOpenFilter: handleOpenFilter,
      displayKey: "email",
    },
    {
      key: "status",
      title: "Status",
      handleOpenFilter: handleOpenFilter,
      displayKey: "status",
      render: (client, index) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            maxWidth: 120,
          }}
        >
          {client.status === "Active" ? (
            <img src="/Dot.png" alt="dot" style={{ marginRight: "8px" }} />
          ) : client.status === "Pending" ? (
            <img
              src="/pending.png"
              alt="pending"
              style={{ marginRight: "8px" }}
            />
          ) : (
            <img
              src="/unnstall.png"
              alt="uninstalled"
              style={{ marginRight: "8px" }}
            />
          )}

          <Typography
            style={{ marginRight: 2, minWidth: 50 }}
            fontSize="13px"
            color={
              client?.status === "Rejected"
                ? "red"
                : client?.status === "Active"
                  ? "#007D14"
                  : client?.status === "Pending"
                    ? "#FF8A00"
                    : client?.status === "Approved"
                      ? "#FF8A00"
                      : "#757477"
            }
            fontWeight={500}
          >
            {client.status}
          </Typography>
          {client.status === "Rejected" ? (
            <></>
          ) : (
            <div
              onClick={(e) => {
                if (!["Pending", "Uninstalled"].includes(client.status)) {
                  e.preventDefault();
                  e.stopPropagation();
                  handleStatusToggle(
                    client._id,
                    client.status,
                    e,
                    client.email,
                  );
                }
              }}
              style={{
                pointerEvents: ["Pending", "Uninstalled"].includes(
                  client.status,
                )
                  ? "none"
                  : "auto",
                opacity: ["Pending", "Uninstalled"].includes(client.status)
                  ? 0.5
                  : 1,
              }}
            >
              {client.status === "Uninstalled" ? (
                <></>
              ) : (
                <IOSSwitch
                  disabled={["Pending"].includes(client.status)}
                  checked={client.status == "Active"}
                />
              )}
            </div>
          )}
        </div>
      ),
    },
    {
      key: "order_exclude_inventory",
      title: "Exclude Inventory",
      handleOpenFilter: handleOpenFilter,
      displayKey: "order_exclude_inventory",
      render: (client, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
          onClick={(e) => {
            setSelectedClient(client);
            setOpenConfirmation(true);
            e.stopPropagation();
          }}
        >
          <IOSSwitch checked={client?.order_exclude_inventory || false} />
        </div>
      ),
    },
    {
      key: "managed_orchestration",
      title: "Managed Orchestration",
      displayKey: "managed_orchestration",
      render: (client, index) => (
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={(e) => {
            setSelectedClient(client);
            setOpenManagedOrchConfirmation(true);
            e.stopPropagation();
          }}
        >
          <IOSSwitch checked={client?.managed_orchestration || false} />
        </div>
      ),
    },
    {
      key: "action",
      title: "",
      displayKey: "action",
    },
  ];

  const ListItem = ({ header, value, gridView }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          padding: "4px 0",
          width: "100%",
        }}
      >
        {/* Header */}
        <div
          style={{
            width: gridView ? "40%" : "40%",
            paddingInline: 10,
            paddingTop: 5,
            paddingBottom: 5,
          }}
        >
          <CustomTypography
            style={{
              textAlign: "left",
              fontSize: 13,
              whiteSpace: "nowrap",
            }}
            fontWeight={600}
            color={"var(--text-tertiary)"}
          >
            {header}
          </CustomTypography>
        </div>

        {/* Value */}
        <div
          style={{
            width: gridView ? "60%" : "60%",
            paddingInline: 10,
            paddingTop: 5,
            paddingBottom: 5,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Tooltip title={typeof value === "string" ? value : ""}>
            <div
              style={{
                fontFamily: "Poppins",
                fontSize: 13,
                color: "var(--text-secondary)",
                fontWeight: 500,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                display: "block",
                maxWidth: "100%",
              }}
            >
              {value}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };

  const renderGridView = () => (
    <Grid sx={{ padding: 1 }} container spacing={2}>
      {clientData?.map((client, index) => (
        <Grid
          sx={{ paddingBottom: 5 }}
          item
          xs={12}
          sm={6}
          md={4}
          key={client.id}
        >
          <Card sx={{ boxShadow: 3, minHeight: 50, position: "relative" }}>
            <Box sx={{ position: "relative", padding: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  fontWeight={500}
                  fontFamily="Poppins"
                  fontSize="14px"
                  color="var(--text-tertiary)"
                >
                  {startIndex + index + 1}
                </Typography>
                <Box sx={{ position: "absolute", top: 8, right: 10 }}>
                  {client?.action}
                </Box>
              </Box>

              <ListItem value={client.name} header={"Client Name"} />
              <ListItem value={client.contact || ""} header={"Mobile No"} />
              <ListItem value={client.email} header={"Email"} />
              <ListItem
                value={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      maxWidth: 120,
                    }}
                  >
                    <CustomTypography
                      style={{ marginRight: 2, minWidth: 50 }}
                      fontSize="13px"
                      color={
                        client?.status === "Rejected"
                          ? "red"
                          : client?.status === "Active"
                            ? "#007D14"
                            : client?.status === "Pending"
                              ? "#FF8A00"
                              : client?.status === "Approved"
                                ? "#FF8A00"
                                : "#757477"
                      }
                      fontWeight={500}
                    >
                      {client.status}
                    </CustomTypography>
                    {client.status !== "Rejected" && (
                      <Box
                        onClick={(e) => {
                          if (
                            !["Pending", "Uninstalled"].includes(client.status)
                          ) {
                            e.preventDefault();
                            e.stopPropagation();
                            handleStatusToggle(
                              client._id,
                              client.status,
                              e,
                              client.email,
                            );
                          }
                        }}
                        sx={{
                          pointerEvents: ["Pending", "Uninstalled"].includes(
                            client.status,
                          )
                            ? "none"
                            : "auto",
                          opacity: ["Pending", "Uninstalled"].includes(
                            client.status,
                          )
                            ? 0.5
                            : 1,
                        }}
                      >
                        {client.status !== "Uninstalled" && (
                          <IOSSwitch
                            disabled={["Pending"].includes(client.status)}
                            checked={client.status === "Active"}
                          />
                        )}
                      </Box>
                    )}
                  </Box>
                }
                header={"Status"}
              />

              <Box sx={{ display: "flex", alignItems: "start" }}>
                <ActionButtons
                  client={client}
                  status={client.status}
                  setOpenOmsModal={setOpenProviderModal}
                  setSelectedClient={setSelectedClient}
                  setTms={setTms}
                  setWms={setWms}
                  setOpenProviderModal={setOpenProviderModal}
                />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
        marginTop: 5,
      }}
    >
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: isMobile() ? "column" : "row",
        }}
      > */}
      {isMobile() ? (
        <ClientMobileCard
          data={data}
          handleMenuOpen={handleMenuOpen}
          handleStatusToggle={handleStatusToggle}
          ListItem={ListItem}
          IOSSwitch={IOSSwitch}
          ActionButtons={ActionButtons}
          menuPosition={menuPosition}
          menuRef={menuRef}
          Action={Action}
          setSelectedClient={setSelectedClient}
          setTms={setTms}
          setWms={setWms}
          setOpenProviderModal={setOpenProviderModal}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
        />
      ) : (
        <TableContainer
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                {TableSchema.map((x) => (
                  <TableHeader
                    filterData={filterData}
                    filterKey={x.key}
                    handleOpenFilter={x.handleOpenFilter}
                    title={x.title}
                  />
                ))}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {clientData?.map((client, index) => (
                <React.Fragment key={index}>
                  <StyledTableRow
                    isExpandable={openRow === client._id}
                    onClick={() => {
                      if (client.status !== "Uninstalled") {
                        handleRowClick(index);
                        setSelectClientId(client?._id);
                        setSelectedClient(client);
                      }
                    }}
                    style={{
                      cursor:
                        client.status === "Uninstalled"
                          ? "not-allowed"
                          : "pointer",
                      backgroundColor: "var(--bg-paper)",
                      borderRadius: 8,
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      border: "none",
                      padding: 0,
                      "&:lastChild td, &:lastChild th": {
                        border: "none",
                      },
                    }}
                  >
                    {TableSchema.map((x) => (
                      <StyledTableCell>
                        {x.render ? (
                          x.render(client, index)
                        ) : (
                          <Typography
                            fontSize="12px"
                            color="var(--text-secondary)"
                            fontWeight={400}
                            fontFamily={"Poppins"}
                          >
                            {client[x.displayKey]}
                          </Typography>
                        )}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                        borderBottom: 0,
                      }}
                      colSpan={8}
                    >
                      <Collapse
                        in={openRow === index}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box margin={1}>
                          {loading ? (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: 9999,
                                color: "white",
                              }}
                            >
                              <CircularProgress color="inherit" />
                            </Box>
                          ) : (
                            <TableContainer
                              sx={{ padding: 1 }}
                              component={Paper}
                            >
                              <ClientConfiguration
                                viewOnly={viewOnly}
                                setOpenOmsModal={setOpenOmsModal}
                                onCloseModal={onCloseModal}
                                selectedData={selectedData}
                                selectedClient={selectedClient}
                                openOmsModal={openOmsModal}
                                providerList={providerList}
                                isOpened={openRow === index}
                                wms={wms}
                                tms={tms}
                                // onDeleteSuccess={() => fetchProviderDetails(client?._id)}
                                isDisabled={[
                                  "Inactive",
                                  "Uninstalled",
                                ].includes(client.status)}
                                onClickAddWms={(e) => {
                                  setWms(true);
                                  setOpenOmsModal(true);
                                  e.stopPropagation();
                                  setSelectedClient(client);
                                }}
                                onClickAddTms={(e) => {
                                  setTms(true);
                                  setOpenOmsModal(true);
                                  e.stopPropagation();
                                  setSelectedClient(client);
                                }}
                                onClickAddOms={(e) => {
                                  e.stopPropagation();
                                  setOpenOmsModal(true);
                                  setSelectedClient(client);
                                }}
                                onViewOmsData={(data) => {
                                  // fetchProviderDetails(client?._id)
                                  setSelectedData([data]);
                                  setSelectedClient(client);
                                  setOpenOmsModal(true);
                                  setViewOnly(true);
                                }}
                                onViewTmsData={(data) => {
                                  // fetchProviderDetails(client?._id)
                                  setSelectedData([data]);
                                  setSelectedClient(client);
                                  setOpenOmsModal(true);
                                  setViewOnly(true);
                                  setTms(true);
                                }}
                                onClickLocation={() =>
                                  setOpenWarehouseList(true)
                                }
                                onViewWmsData={(data) => {
                                  // fetchProviderDetails(client?._id)
                                  setSelectedData([data]);
                                  setSelectedClient(client);
                                  setOpenOmsModal(true);
                                  setWms(true);
                                  setTms(false);
                                  setViewOnly(true);
                                }}
                                onEditWms={(data) => {
                                  // fetchProviderDetails(client?._id)
                                  setSelectedData([data]);
                                  setSelectedClient(client);
                                  setOpenOmsModal(true);
                                  setWms(true);
                                  setTms(false);
                                }}
                                onEditTms={(data) => {
                                  // fetchProviderDetails(client?._id)
                                  setSelectedData([data]);
                                  setSelectedClient(client);
                                  setOpenOmsModal(true);
                                  setWms(false);
                                  setTms(true);
                                }}
                                onEditOms={(data) => {
                                  // fetchProviderDetails(client?._id)
                                  setSelectedData([data]);
                                  setSelectedClient(client);
                                  setOpenOmsModal(true);
                                }}
                                providerData={providerData}
                                clientId={client?._id}
                                setSelectedProvider={(provider) =>
                                  setSelectedProvider(provider)
                                }
                              ></ClientConfiguration>
                            </TableContainer>
                          )}
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {/* </div> */}
    </div>
  );
  return (
    <div sx={{ minWidth: "100%" }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <></>
      )}
      <div
        style={{
          overflowY: "scroll",
          display: "flex",
          maxHeight: isMobile() ? "70vh" : `calc(100vh - 200px)`,
          width: "100%",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::WebkitScrollbar": { width: 0 },
          paddingBottom: isMobile() ? 25 : 0,
        }}
      >
        {viewMode === "grid" ? renderGridView() : renderListView()}
      </div>
      <DeleteConfirmationModal
        title={`Are you sure to ${
          selectedClient?.order_exclude_inventory ? "disable" : "enable"
        } exclude inventory?`}
        open={openConfirmation}
        handleClose={() => setOpenConfirmation(false)}
        handleDelete={(e) => {
          handleExcludeInventoryToggle(
            selectedClient._id,
            selectedClient?.order_exclude_inventory,
          );
          setOpenConfirmation(false);
        }}
        deleteButtonTitle={`Yes`}
      />
      <DeleteConfirmationModal
        title={`Are you sure to ${
          selectedClient?.managed_orchestration ? "disable" : "enable"
        } managed orchestration?`}
        open={openManagedOrchConfirmation}
        handleClose={() => setOpenManagedOrchConfirmation(false)}
        handleDelete={() => {
          handleManagedOrchestrationToggle(
            selectedClient._id,
            selectedClient?.managed_orchestration,
          );
          setOpenManagedOrchConfirmation(false);
        }}
        deleteButtonTitle={`Yes`}
      />

      <ClientDetailsModal
        onSuccess={onSuccess}
        client={selectedClient}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
      <WarehouseSelectionModal
        selectedProvider={selectedProvider}
        onClose={() => setOpenWarehouseList(false)}
        open={openWarehouseList}
        providerList={providerList}
        providers={providerList.filter((x) => x.type === "WMS")}
        filterData={filterData}
        selectedfilterData={selectedfilterData}
        handleSaveFilter={handleSaveFilter}
        anchorElFilter={anchorElFilter}
        openFilterModal={openFilterModal}
        setOpenFilterModal={setOpenFilterModal}
        setSelectedFilterData={setSelectedFilterData}
        setAnchorElFilter={setAnchorElFilter}
        selectedClient={selectedClient}
        setSelectedProvider={setSelectedProvider}
      ></WarehouseSelectionModal>
      <ClientProviderModal
        open={openProviderModal}
        setOpen={setOpenProviderModal}
        onClose={() => {
          setOpenProviderModal(false);
          setTms(false);
          setWms(false);
        }}
        oms={!tms && !wms}
        tms={tms}
        wms={wms}
        selectedClient={selectedClient}
        selectedData={selectedData.map((x) => ({
          ...x,
          provider: x?.provider?._id,
        }))}
        viewOnly={viewOnly}
        setLoading={setLoading}
        loading={loading}
        onAddProviderData={() => onCloseModal()}
        onDeleteSuccess={() => {
          setOpenProviderModal(false);
        }}
      />
      <ClientSetupStatusModal
        open={setupModalOpen}
        onClose={() => setSetupModalOpen(false)}
        client={selectedClient}
      />
      <Dialog
        open={syncModalOpen}
        onClose={handleCloseSyncModal}
        aria-labelledby="sync-modal-title"
        PaperProps={{
          sx: {
            width: { xs: "90vw", sm: 460 },
            maxWidth: "95vw",
            borderRadius: 3,
            backgroundColor: "var(--bg-paper)",
            backgroundImage: "none",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          id="sync-modal-title"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            py: 2.5,
            px: 3,
            borderBottom: "1px solid var(--border-color)",
          }}
        >
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: `${primary_color}1a`,
              color: primary_color,
              flexShrink: 0,
            }}
          >
            <SyncAltIcon sx={{ fontSize: 24 }} />
          </Box>
          <Box>
            <Typography
              fontFamily={"poppins"}
              fontSize={"17px"}
              fontWeight={600}
              color={"var(--text-primary)"}
              lineHeight={1.3}
            >
              Sync Historical Data
            </Typography>
            {(syncClient?.business_name || syncClient?.name) && (
              <Typography
                fontFamily={"poppins"}
                fontSize={"13px"}
                color={"var(--text-secondary)"}
              >
                {syncClient?.business_name || syncClient?.name}
              </Typography>
            )}
          </Box>
        </DialogTitle>
        <DialogContent sx={{ px: 3, pb: 1, pt: "20px !important" }}>
          <Typography
            fontFamily={"poppins"}
            fontSize={"13px"}
            color={"var(--text-secondary)"}
            sx={{ mb: 2.5, lineHeight: 1.5 }}
          >
            Select the date range for which historical orders should be synced.
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
              <DateTimePicker
                label="Start Date & Time"
                value={syncStartDate}
                onChange={(newValue) => setSyncStartDate(newValue)}
                maxDateTime={syncEndDate || dayjs()}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "medium",
                    sx: syncDateFieldSx,
                  },
                }}
              />
              <DateTimePicker
                label="End Date & Time"
                value={syncEndDate}
                onChange={(newValue) => setSyncEndDate(newValue)}
                minDateTime={syncStartDate || dayjs()}
                maxDateTime={dayjs()}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "medium",
                    sx: syncDateFieldSx,
                  },
                }}
              />
            </Box>
          </LocalizationProvider>

          {syncError && (
            <Box
              sx={{
                mt: 2,
                p: 1.5,
                backgroundColor: "rgba(220, 38, 38, 0.08)",
                border: "1px solid rgba(220, 38, 38, 0.3)",
                borderRadius: 2,
                color: "#dc2626",
                fontSize: 13,
                fontWeight: 500,
                fontFamily: "poppins",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              ⚠️ {syncError}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2.5, gap: 1.5 }}>
          <Button
            onClick={handleCloseSyncModal}
            variant="outlined"
            sx={{
              minWidth: 100,
              borderRadius: 2,
              borderColor: "var(--border-color)",
              color: "var(--text-secondary)",
              fontWeight: 600,
              textTransform: "none",
              fontSize: 14,
              fontFamily: "poppins",
              "&:hover": {
                borderColor: "var(--text-secondary)",
                backgroundColor: "transparent",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSyncConfirm}
            variant="contained"
            startIcon={<SyncAltIcon sx={{ fontSize: 18 }} />}
            sx={{
              minWidth: 130,
              borderRadius: 2,
              backgroundColor: primary_color,
              fontWeight: 600,
              textTransform: "none",
              fontSize: 14,
              fontFamily: "poppins",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: primary_color,
                boxShadow: `0 4px 14px 0 ${primary_color}40`,
              },
            }}
          >
            Sync Data
          </Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={Boolean(anchorElFilter)}
        anchorEl={anchorElFilter}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock={true}
      >
        <FilterModal
          open={openFilterModal}
          onClose={handleCloseFilter}
          options={selectedfilterData?.options}
          selectedValues={selectedfilterData?.filter}
          onSave={handleSaveFilter}
          currentSortOrder={selectedfilterData?.sort}
          filterKey={selectedfilterData?.key}
          hasMore={selectedfilterData?.loadMoreButton}
          displayKey={selectedfilterData?.displayKey}
          id={selectedfilterData?.id}
          fetchApi={selectedfilterData?.fetchApi}
          searchKey={selectedfilterData?.searchKey}
          type={selectedfilterData?.type}
        />
      </Popover>

      {/* Assign User — choose action dialog */}
      <Dialog
        open={openAssignUserChoice}
        onClose={() => setOpenAssignUserChoice(false)}
        PaperProps={{
          sx: {
            backgroundColor: "var(--bg-paper)",
            backgroundImage: "none",
            borderRadius: 2,
            width: 380,
          },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <DialogTitle
            sx={{
              fontFamily: "Poppins",
              fontSize: 18,
              fontWeight: 600,
              color: "var(--text-primary)",
            }}
          >
            Assign User
          </DialogTitle>
          <IconButton
            onClick={() => setOpenAssignUserChoice(false)}
            sx={{ mr: 1 }}
          >
            <PersonAddIcon sx={{ color: "var(--text-secondary)" }} />
          </IconButton>
        </Box>
        <Divider />
        <DialogContent>
          <Typography
            fontFamily="Poppins"
            fontSize={13}
            color="var(--text-secondary)"
            sx={{ mb: 2 }}
          >
            How would you like to add a user for{" "}
            <strong style={{ color: "var(--text-primary)" }}>
              {selectedClient?.business_name || selectedClient?.name}
            </strong>
            ?
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<PersonAddIcon />}
              onClick={() => {
                setOpenAssignUserChoice(false);
                setOpenCreateAndAssign(true);
              }}
              sx={{
                textTransform: "none",
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: 14,
                justifyContent: "flex-start",
                px: 2,
                py: 1.2,
                borderColor: "var(--border-color)",
                color: "var(--text-primary)",
                "&:hover": { borderColor: primary_color, color: primary_color },
              }}
            >
              Create User and Assign
            </Button>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<PersonIcon />}
              onClick={() => {
                setOpenAssignUserChoice(false);
                setOpenAssignExisting(true);
              }}
              sx={{
                textTransform: "none",
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: 14,
                justifyContent: "flex-start",
                px: 2,
                py: 1.2,
                borderColor: "var(--border-color)",
                color: "var(--text-primary)",
                "&:hover": { borderColor: primary_color, color: primary_color },
              }}
            >
              Assign User
            </Button>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setOpenAssignUserChoice(false)}
            variant="text"
            sx={{
              fontFamily: "Poppins",
              fontSize: 13,
              textTransform: "none",
              color: "var(--text-secondary)",
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create User and Assign modal */}
      <UserModal
        open={openCreateAndAssign}
        handleClose={() => setOpenCreateAndAssign(false)}
        onAddData={() => {
          setOpenCreateAndAssign(false);
          onSuccess && onSuccess();
        }}
        selectedUser={null}
        client_id={selectedClient?._id}
      />

      {/* Assign Existing User modal */}
      <AssignExistingUserModal
        open={openAssignExisting}
        onClose={() => setOpenAssignExisting(false)}
        clientId={selectedClient?._id}
        onSuccess={() => onSuccess && onSuccess()}
      />

      <ForecastSettingsDialog
        open={Boolean(forecastSettingsClient)}
        onClose={() => setForecastSettingsClient(null)}
        clientId={forecastSettingsClient?._id}
        clientName={forecastSettingsClient?.business_name || forecastSettingsClient?.name}
      />
    </div>
  );
};

export default ClientList;
